// src/pages/BlogDetails.js
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import client from "../contentfulClient";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

function BlogDetails() {
  const { id } = useParams(); // blog ID from URL
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const entries = await client.getEntries({
          content_type: "blogs",
          "sys.id": id,
          limit: 1,
        });

        if (entries.items.length > 0) {
          const item = entries.items[0];
          const imageAsset = entries.includes?.Asset?.find(
            (asset) => asset.sys.id === item.fields.blogImage?.sys?.id
          );

          const imageUrl = imageAsset?.fields?.file?.url
            ? "https:" + imageAsset.fields.file.url
            : "https://via.placeholder.com/600x400";

          setBlog({
            id: item.sys.id,
            name: item.fields.blogName,
            description: item.fields.descriptions,
            image: imageUrl,
            longDescription: item.fields.longDescription,
          });
        }
      } catch (error) {
        console.error("Error fetching blog:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);

  if (loading) return <p className="text-center py-5">Loading blog...</p>;
  if (!blog) return <p className="text-center py-5">Blog not found.</p>;

  return (
    <div className="blog-details-page">
      {/* Banner Section */}
      <section className="about-banner position-relative overflow-hidden">
        <div className="container text-center position-relative z-index-1">
          <h1 className="display-5 fw-bold mb-3">{blog.name}</h1>
          <p className="lead">{blog.description}</p>
        </div>
      </section>

      {/* Blog Content */}
      <section className="blog-content py-5 bg-light">
        <div className="container py-5">
          {blog.image && (
            <img
              src={blog.image}
              alt={blog.name}
              className="img-fluid mb-4"
              style={{ maxHeight: "400px", objectFit: "cover", width: "100%" }}
            />
          )}

          {blog.longDescription &&
            documentToReactComponents(blog.longDescription)}

          <div className="mt-4">
            <button
              className="btn btn-primary"
              onClick={() => navigate("/blogs")}
            >
              Back to Blogs
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BlogDetails;
